import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=17df770e&scoped=true"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"
import style0 from "./Channel.vue?vue&type=style&index=0&id=17df770e&prod&scoped=true&lang=css"
import style1 from "./Channel.vue?vue&type=style&index=1&id=17df770e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17df770e",
  null
  
)

export default component.exports